import { MarkButton } from '../../../components/MarkControls';
import React from 'react';
import type { BlastStatus } from '../../../types';
import useBlastActions from '../../../hooks/useBlastActions';
type Props = {
    status: BlastStatus | undefined;
    disableLifecycle?: boolean;
    onEdit: () => void;
    onPublish: () => void;
    onSchedule: () => void;
    onCancel: () => void;
    onResume: () => void;
};
const ActionButton: React.FC<{
    label: string;
    onClick: () => void;
    variant?: 'primary' | 'danger' | 'default';
    disabled?: boolean;
}> = ({ label, onClick, variant = 'default', disabled = false }) => {
    return (
        <MarkButton
            type="button"
            onClick={onClick}
            variant={variant === 'primary' ? 'primary' : 'outlineSecondary'}
            tone={variant === 'danger' ? 'danger' : undefined}
            size="regular"
            disabled={disabled}
        >
            {label}
        </MarkButton>
    );
};
const ActionsBar: React.FC<Props> = ({
    status,
    disableLifecycle = false,
    onEdit,
    onPublish,
    onSchedule,
    onCancel,
    onResume
}) => {
    const actions = useBlastActions(status);
    if (!status) return null;
    return (
        <div
            style={{
                display: 'flex',
                gap: '0.8rem',
                flexWrap: 'wrap'
            }}
        >
            {actions.canEdit && <ActionButton label="Edit" onClick={onEdit} />}
            {actions.canPublish && (
                <ActionButton
                    label="Publish now"
                    onClick={onPublish}
                    variant="primary"
                    disabled={disableLifecycle}
                />
            )}
            {actions.canSchedule && (
                <ActionButton
                    label={status === 'SCHEDULED' ? 'Reschedule' : 'Schedule'}
                    onClick={onSchedule}
                    disabled={status === 'DRAFT' && disableLifecycle}
                />
            )}
            {actions.canCancel && (
                <ActionButton label="Cancel" onClick={onCancel} variant="danger" />
            )}
            {actions.canResume && (
                <ActionButton label="Resume" onClick={onResume} variant="primary" />
            )}
        </div>
    );
};
export default ActionsBar;
